import React from 'react'
import { StyleSvgWrapper } from './style'

interface SVGProps {
  src: string
  className?: string
  title?: string
  styleSvg?: string
  onClick?: (data: any) => void
}

const sanitizeSvg = (raw: string) => {
  try {
    const withoutScripts = raw.replace(/<\/?script[^>]*>/gi, '')
    const withoutHandlers = withoutScripts
      .replace(/on[a-z]+\s*=\s*"[^"]*"/gi, '')
      .replace(/on[a-z]+\s*=\s*'[^']*'/gi, '')

    const withoutJsUrls = withoutHandlers
      .replace(/xlink:href\s*=\s*"javascript:[^"]*"/gi, '')
      .replace(/xlink:href\s*=\s*'javascript:[^']*'/gi, '')
    return withoutJsUrls
  } catch (_) {
    return ''
  }
}

const Svg: React.FC<SVGProps> = ({
  src,
  className,
  title,
  styleSvg,
  onClick,
}) => {
  return (
    <StyleSvgWrapper
      styleSvg={styleSvg}
      role="img"
      aria-label={title}
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: sanitizeSvg(src) }}
    />
  )
}

export default Svg
